/*
 * @Author:
 * @Description:
 * @Date: 2024-09-09 16:47:05
 * @LastEditors: Please set LastEditors
 * @FilePath: /rhcn-merchant-web/src/utils/options/common.js
 */
export const statusList = [
  { label: 'message.searchCommon.all', value: '' },
  { label: 'message.status.yes', value: '1' },
  { label: 'message.status.no', value: '0' },
];
